"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uiSchema_1 = require("../../common/appointment/uiSchema");
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Control",
            label: "Missed Visit Date",
            scope: "#/properties/missedVisitDate",
            options: {
                format: "date",
                disableFuture: true,
            },
        },
        {
            type: "Control",
            label: "Reason",
            scope: "#/properties/reason",
        },
        (0, uiSchema_1.makeAppointmentUiSchema)("futureAppointment", "Next Visit", {
            disablePast: true,
        }),
        (0, uiSchema_1.makeAppointmentConflictsUiSchema)("futureAppointment"),
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
